import { faCalendar, faClock } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { orderListDetailApi } from '../../Api/SupplierServices'
import EachComment from '../EachComment/EachComment'
import Factor from '../Factor/Factor'
import Modal from '../Modal/Modal'
import Style from './CommentList.module.css'
import { splitJalaliDateTime } from '../../Functions/convertDateToJalali'

const CommentList = ({ data, updateList }) => {
  const [purchased, setPurchased] = useState(false);
  const [orderInfo, setOrderInfo] = useState();
  const [orderID, setOrderID] = useState();

  const getOrderListHandler = (id) => {
    setOrderID(id);
    setOrderInfo(undefined);
    setPurchased(true);
    orderDetail(id);
  };

  const orderDetail = async (id) => {
    try {
      const result = await orderListDetailApi(id);
      setOrderInfo(result);
    } catch (err) {
      setOrderInfo({ products: [] });
    }
  };

  const { date: orderDate, time: orderTime } = splitJalaliDateTime(orderInfo?.date);

  return (
    <ul className={Style.ComponentHolder}>
      <Modal show={purchased} modalClose={() => setPurchased(false)} translate={20}>
        {orderInfo && (orderDate || orderTime) ? (
          <div className={Style.DateOrder}>
            <h4>
              <FontAwesomeIcon icon={faCalendar} /> {orderDate}
            </h4>
            <p>
              <FontAwesomeIcon icon={faClock} /> {orderTime}
            </p>
          </div>
        ) : null}
        <Factor orderID={orderID} data={orderInfo} />
      </Modal>

      {Array.isArray(data) &&
        data.slice(0).reverse().map((item) => (
          <EachComment
            key={item.id}
            item={item}
            updateList={updateList}
            getOrderListHandler={getOrderListHandler}
          />
        ))}
    </ul>
  );
};

export default CommentList;
